import ContentTV from './ContentTV';
const FEEDTYPE_FILTER = {
    home: true,
    away: true,
    national: true,
    nd: true // this is for MiLB
};

class ContentTVList {

    constructor(mlbtv, mediaType) {
        this.parseData(mlbtv, mediaType);
    }

    parseData (tv, mediaType) {
        if (tv) {
            let i = 0;
            let len = tv.length;
            let list = this.list = [];
            let lang = this.language = {};
            let id = this.id = {};
            let media;
            this.title = mediaType;

            for (; i < len; i++) {
                media = new ContentTV(tv[i]);

                if (FEEDTYPE_FILTER[media.mediaFeedTypeKey]) {
                    (lang[media.language] = lang[media.language] || []).push(media);
                    (id[media.id] = lang[media.id] || []).push(media);
                    list.push(media);
                }
            }

        }
    }
}

export default ContentTVList;
